const pagesItemLedgerEn = {
  actionAdd: 'Add Item',
  actionCancel: 'Cancel',
  actionChangeStatus: 'Change Status',
  actionEdit: 'Edit',
  actionSave: 'Save',
  changeStatusDialogTitle: 'Change Status',
  changeStatusReasonPlaceholder: 'Reason (optional)',
  createDialogTitle: 'Add Item',
  detailPageTitle: 'Item Detail',
  editDialogTitle: 'Edit Item',
  fieldBaseUnit: 'Base Unit',
  fieldCreatedAt: 'Created At',
  fieldCurrency: 'Currency',
  fieldDescription: 'Description',
  fieldItemNumber: 'Item Number',
  fieldItemType: 'Item Type',
  fieldLeadTimeDays: 'Lead Time (days)',
  fieldMaxOrderQty: 'Max Order Qty',
  fieldMinOrderQty: 'Min Order Qty',
  fieldMinSalesQty: 'Min Sales Qty',
  fieldName: 'Name',
  fieldOrderMultiple: 'Order Multiple',
  fieldProfileStatus: 'Status',
  fieldSalesLeadTimeDays: 'Sales Lead Time (days)',
  fieldSalesPrice: 'Standard Sales Price',
  fieldStandardPrice: 'Standard Price',
  fieldStatus: 'Status',
  fieldTargetStatus: 'Target Status',
  fieldUpdatedAt: 'Updated At',
  itemStatus: {
    ACTIVE: 'Active',
    ARCHIVED: 'Archived',
    BLOCKED: 'Blocked',
    DRAFT: 'Draft',
    OBSOLETE: 'Obsolete'
  },
  itemTypeOption: {
    FERT: 'Finished',
    FOOD: 'Food',
    HALB: 'Semi-finished',
    HAWA: 'Merchandise',
    ROH: 'Raw Material'
  },
  listFilterAll: 'All',
  listFilterPlaceholder: 'Search by item number or name...',
  listFilterType: 'Item Type',
  listPageTabAlert: 'Alert',
  listPageTabBom: 'Bom',
  listPageTabDealModeView: 'DealModeView',
  listPageTabItemList: 'ItemList',
  listPageTabOperationActivity: 'Operation & Activity',
  listPageTabOverview: 'Overview',
  listPageTabRulePolicy: 'Rule & Policy',
  listPageTabSetting: 'Setting',
  listPageTitle: 'Item',
  procurementNotSet: 'Procurement profile not configured',
  profileStatus: {
    ACTIVE: 'Active',
    DISCONTINUED: 'Discontinued',
    DRAFT: 'Draft',
    SUSPENDED: 'Suspended'
  },
  salesNotSet: 'Sales profile not set',
  sectionIdentity: 'Identity',
  sectionProcurement: 'Procurement Profile',
  sectionSales: 'Sales Profile'
};
export default pagesItemLedgerEn;